import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import Hero from './components/Hero';
import Image from '../BaseComponent/Image';
import TitleH4 from '../BaseComponent/TitleH4';
import Input from '../BaseComponent/Input';
import Select from '../BaseComponent/Select';
import $ from 'jquery';
import axios from 'axios'

class Registrasi extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      newUser:{
        nameMitra: '',
        email: '',
        telp: '',
        gender: '',
        venicle:'',
        type:'',
        merk:'',
        nopol:'',
        years:'',
        findAt:'',
        city:''   
      },
      cityOptions:["Malang", "Blitar","Surabaya"],
      genderOptions:["Laki-laki","Perempuan"],
      yearsOptions:["2000","2001","2004","2009"],
      findAtOptions:["Google","Temen","Instagram","Facebook","Twitter","Lainnya"],
      merkOptions:["Yamaha","Honda","Suzuki"],
      venicleOptions:["Motor","Mobil"]
    };
  
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleClearForm = this.handleClearForm.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }
  handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState(
      prevState => ({
        newUser: {
          ...prevState.newUser,
          [name]: value
        }
      }),
      () => console.log(this.state.newUser)
    );
  }
  
  handleFormSubmit(e) {
    e.preventDefault();
    let userData = this.state.newUser;

    // fetch("http://debug.deliv.co.id:3000/api/mitra/register/driver", {
    //   method: "POST",
    //   body: JSON.stringify(userData),
    //   headers: {
    //     Accept: "application/json",
    //     "Content-Type": "application/json"
    //   }
    // }).then(response => {
    //   response.json().then(data => {
    //     console.log("Successful" + data);
    //   });
    // });

    axios({
      method: 'post',
      url: 'http://debug.deliv.co.id:3000/api/mitra/register/driver',
      data: userData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
      })
      .then(function (response) {
          //handle success
          console.log(response);
          console.log(userData);
      })
      .catch(function (response) {
          //handle error
          console.log(response);
      });
  }
  
  handleClearForm(e) {
  
    e.preventDefault();
    this.setState({ 
      newUser: {
        nameMitra: '',
        email: '',
        telp: '',
        gender: '',
        venicle:'',
        type:'',
        merk:'',
        nopol:'',
        years:'',
        findAt:'',
        city:''   
      },
    });
}
  //  handleSubmit = (e, message) => {
  //   e.preventDefault()
  
  //   let formData = {
  //    formName: this.state.name,
  //    formCity: this.state.city,
  //    formType: this.state.type,
  //    formEmail: this.state.email,
  //    formGender: this.state.gender,
  //    formNopol: this.state.nopol,
  //    formTelp: this.state.telp,
  //    formVenicle: this.state.venicle,
  //    formYears: this.state.years,
  //    formFindAt: this.state.findAt,
  //    formMerk: this.state.merk
  //   }
  
  //   if (formData.formName.length < 1 || formData.formCity.length < 1 || formData.formType.length < 1 || 
  //     formData.formEmail.length < 1 || formData.formGender.length < 1 || formData.formNopol.length < 1 || formData.formTelp.length < 1 || formData.formVenicle.length < 1 || formData.formYears.length < 1 || formData.formFindAt.length < 1 || formData.formMerk.length < 1 ) {
  //    return false
  //   }
  
  //   $.ajax({
  //    url: 'http://debug.deliv.co.id:3000/api/mitra/register/driver',
  //    dataType: 'json',
  //    type: 'POST',
  //    data: formData,
  //    success: function(data){
  //        console.log(data);
  //    },
  //    error: function(xhr, status, err) {
  //     console.error(status, err.toString())
  //     alert('There was some problem with sending your message.')
  //    }
  //   })
  
  
  //   this.setState({
  //     nameMitra: '',
  //     email: '',
  //     telp: '',
  //     gender: '',
  //     venicle:'',
  //     type:'',
  //     merk:'',
  //     nopol:'',
  //     years:'',
  //     findAt:'',
  //     city:''
  //   })
   
  

   render() {
    return (
      <div>
        <Hero
        title="Registrasi Mitra Driver"
        subtitle="Bergabung bersama ratusan Mitra Driver DELIV"
        />
        <section className="pendaftaran">
          <div className="container">
            <div className="columns">
              <div className="column is-flex">
              <Image
              styleName="image has-image-centered"
              image="img/about/DSC_1118-min.JPG"
              alt="Mitra DELIV"
              />
              </div>
              <div className="column is-offset-1 ">
                <div className="card">
                  <header className="card-header has-text-centered ">
                    <div className="card-header-title ">Registrasi Driver</div>
                  </header>
                  <div className="card-content">
                    <form onSubmit={this.handleFormSubmit} className="columns">                    
                      <div className="column ">
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            Nama
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"text"}
                            name={"nameMitra"}
                            value={this.state.newUser.nameMitra}
                            placeholder={"Nama"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            {/* <input
                              className="input is-small"
                              type="text"
                              placeholder="Nama"
                              id="formName"
                              name="nameMitra"
                              required
                              onChange={this.handleChange} value={this.state.name}
                            /> */}
                            <span className="icon is-small is-left">
                              <i className="fas fa-user" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            Email
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"email"}
                            name={"email"}
                            value={this.state.newUser.email}
                            placeholder={"Email"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            {/* <input
                              className="input is-small"
                              type="email"
                              placeholder="Email"
                              id="formEmail"
                              name="email"
                              required
                              onChange={this.handleChange} value={this.state.email}
                            
                            /> */}
                            <span className="icon is-small is-left">
                              <i className="fas fa-envelope" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            No. HP
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"number"}
                            name={"telp"}
                            value={this.state.newUser.telp}
                            placeholder={"Telp"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            {/* <input
                              className="input is-small"
                              type="number"
                              placeholder="No. HP"
                              id="formTelp"
                              name="telp"
                              required
                              onChange={this.handleChange} value={this.state.telp}
                            
                            /> */}
                            <span className="icon is-small is-left">
                              <i className="fas fa-phone" />
                            </span>
                          </div>
                        </div>

                        <div className="field">
                          <div className="control has-icons-left">
                            <label htmlFor="" className="label is-small">
                              Mengetahui Deliv?
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="findAt"
                            options={this.state.findAtOptions}
                            value={this.state.newUser.findAt}
                            placeholder={"Pilih Info"}
                            handleChange={this.handleInput}
                            />
                              {/* <select>
                                <option value="google">Google</option>
                                <option value="instagram">Instagram</option>
                                <option value="facebook">Facebook</option>
                                <option value="twitter">Twitter</option>
                                <option value="whatsapp">Whatsapp</option>
                                <option value="lainnya">Lainnya</option>
                              </select> */}
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-globe" />
                            </span>
                          </div>
                            </div>
                        </div>
                      </div>
                      <div className="column">
                      <div className="field">
                         
                            <label htmlFor="" className="label is-small">
                              Kota
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="city"
                            options={this.state.cityOptions}
                            value={this.state.newUser.city}
                            placeholder={"Pilih Kota"}
                            handleChange={this.handleInput}
                            />
                              {/* <select>
                                <option value="malang">Malang</option>
                                <option value="jakarta">Jakarta</option>
                                <option value="surabaya">Surabaya</option>
                              </select> */}
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-map" />
                            </span>
                          </div>
                            
                        </div>
                        <div className="field">
                          
                            <label htmlFor="" className="label is-small">
                              Jenis Kelamin
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="gender"
                            options={this.state.genderOptions}
                            value={this.state.newUser.gender}
                            placeholder={"Jenis Kelamin"}
                            handleChange={this.handleInput}
                            />
                              {/* <select>
                                <option value="laki-laki">Laki-laki</option>
                                <option value="perempuan">Perempuan</option>
                              </select> */}
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-user-tag" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                         
                            <label htmlFor="" className="label is-small">
                              Jenis Kendaraan
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="venicle"
                            options={this.state.venicleOptions}
                            value={this.state.newUser.venicle}
                            placeholder={"Pilih Kendaraan"}
                            handleChange={this.handleInput}
                            />
                              {/* <select name="" id="">
                                <option value="motor">Motor</option>
                                <option value="mobil">Mobil</option>
                              </select> */}
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-motorcycle" />
                            </span>
                          </div>
                        </div>
                        <div className="field">

                            <label htmlFor="" className="label is-small">
                              Merk Kendaraan
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="merk"
                            options={this.state.merkOptions}
                            value={this.state.newUser.merk}
                            placeholder={"Pilih Merk"}
                            handleChange={this.handleInput}
                            />
                              {/* <select name="" id="">
                                <option value="honda">Honda</option>
                                <option value="yamaha">Yamaha</option>
                              </select> */}
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-bookmark" />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="column">
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            Tipe Kendaraan
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"text"}
                            name={"type"}
                            value={this.state.newUser.type}
                            placeholder={"Type Kendaraan"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            {/* <input
                              className="input is-small"
                              type="text"
                              placeholder="Tipe Kendaraan"
                              id="formType"
                              name="type"
                              required
                              onChange={this.handleChange} value={this.state.type}
                            
                            /> */}
                            <span className="icon is-small is-left">
                              <i className="fas fa-book-open" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                         
                            <label htmlFor="" className="label is-small">
                              No. Polisi
														</label>
                            <div className="control has-icons-left">
                            <Input
                            inputType={"number"}
                            name={"nopol"}
                            value={this.state.newUser.nopol}
                            placeholder={"No. Polisi"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            {/* <input
                              className="input is-small"
                              type="text"
                              placeholder="Nomor Polisi"
                              id="formNopol"
                              name="nopol"
                              required
                              onChange={this.handleChange} value={this.state.nopol}
                            
                            /> */}
                            <span className="icon is-small is-left">
                              <i className="fas fa-landmark" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                         
                            <label htmlFor="" className="label is-small">
                              Tahun Kendaraan
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="years"
                            options={this.state.yearsOptions}
                            value={this.state.newUser.years}
                            placeholder={"Pilih Tahun"}
                            handleChange={this.handleInput}
                            />
                              {/* <select name="" id="">
                                <option value="2000">2000</option>
                                <option value="2001">2001</option>
                                <option value="2002">2002</option>
                                <option value="2003">2003</option>
                                <option value="2004">2004</option>
                              </select> */}
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-calendar-alt" />
                            </span>
                          </div>
                        </div>
                        <div className="field is-flex is-horizontal-center">
                          <div className="control">
                            <br />
                            <button className="button is-link is-small" type="submit ">Submit</button>
                          </div>
                        </div>
                      </div>
                      </form>
                    
                  </div>
                </div>
              </div>
              {/* End Column */}
            </div>
            {/* End Columns */}
            {/* Start Reason Registrasi */}
          </div>
        </section>
        <section id="pendaftaran-alasan">
          <div className="container">
            <div className="content has-text-centered">
              <Fade left>
                <h2 className="title is-uppercase">Bergabunglah dengan Deliv</h2>
                <p className="subtitle">Kenali kami lebih jauh</p>
              </Fade>
            </div>
            <div className="columns">
              <Fade left cascade>
                <div className="column galery_registrasi ">
                <Image
                styleImage="image"
                image="/img/registrasi/regis-1.JPG"
                />
                <Image
                styleImage="image"
                image="/img/registrasi/regis-2.JPG"
                />
                <Image
                styleImage="image"
                image="/img/registrasi/regis-3.JPG"
                />
                <Image
                styleImage="image"
                image="/img/registrasi/regis-4.JPG"
                />
                </div>
              </Fade>
              <div className="column font-small">
                <ul>
                  <li>
                    <Fade left>
                    <TitleH4 
                    title="Karya Anak Bangsa"
                    subtitle=" Para driver yang terpercaya dan berkendaran dengan nyaman dan aman
                    menjadi salah satu poin utama kami"
                    />
                    </Fade>
                  </li>
                  <li>
                    <Fade left>
                      <TitleH4
                      title="Jam Kerja Flexsibel"
                      subtitle="Para driver yang terpercaya dan berkendaran dengan nyaman dan aman
                      menjadi salah satu poin utama kami"
                      />
                    </Fade>
                  </li>
                  <li>
                    <Fade left>
                    <TitleH4
                    title="Pendapatan Meningkat"
                    subtitle="Para driver yang terpercaya dan berkendaran dengan nyaman dan aman
                    menjadi salah satu poin utama kami"
                    />
                    </Fade>
                  </li>
                  <li>
                    <Fade left>
                      <TitleH4
                      title="Pengguna Deliv Puluhan Ribu"
                      subtitle="Para driver yang terpercaya dan berkendaran dengan nyaman dan aman
                      menjadi salah satu poin utama kami"
                      />
                    </Fade>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Registrasi;
